<template>
  <div class="home-top">
    <div class="home-top__image">
      <ModuleImage :imageUrl="image" :lazyLoad="false" :placeholderUrl="placeholderImage"/>
    </div>
    <div class="home-top__content">
      <div class="home-top__header">
        <h1 class="home-top__header__heading">{{heading}}</h1>
      </div>
      <div class="home-top__text">
        <BaseText align="center"><p>{{text}}</p></BaseText>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeTop',
  props: {
    image: String,
    placeholderImage: String,
    heading: String,
    text: String
  }
}
</script>

<style lang="scss" scoped>
    @import './home-top'
</style>



// WEBPACK FOOTER //
// src/views/ViewHome/components/HomeTop/HomeTop.vue